export default {
  name: 'NiotaClassicGwMgmtTimeIntervalRefresh',
  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: ''
    },
    outlined: {
      type: Boolean,
      required: false,
      default: true
    },
    filled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      timeIntMinutes: 0
    };
  },
  computed: {
    requiredRule() {
      return [v => !!v || parseInt(v) === 0 || parseInt(v) < 0 || this.$i18n_t('Common.fieldRequired')];
    }
  },
  methods: {
    setTimeIntervalRefresh() {
      this.$store.commit('app/setRefreshGMMinutes', this.timeIntMinutes);
      this.$emit('close');
    }
  }
};